module.exports = __webpack_public_path__ + "img/lender_benefit_branding.619da2af.jpg";